$.initialiseAdvancedFilter = () => {
  const advanceFilterButtons = $('.js-advanced-filter');
  if(advanceFilterButtons.length) {
    advanceFilterButtons.each( function(i,el) {

      const button = $(el).find('.js-advanced-filter__btn');
      const section = $(el).parent().find('.js-advanced-filter__section');
      const fields = $(el).siblings('.sentence-dropdown');

      const buttonClose = el.parentElement.querySelector('.js-advanced-filter__btn--close');

      button.on('click', () => {
        section.toggleClass('show');
        $(el).toggleClass('advanced-filter--hide');
        button.toggleClass('advanced-filter--hide');
        fields.toggleClass('advanced-filter--hide');
      })

      buttonClose.addEventListener('click', () => {
          section.toggleClass('show');
          $(el).toggleClass('advanced-filter--hide');
          button.toggleClass('advanced-filter--hide');
          fields.toggleClass('advanced-filter--hide');


      })
    })
  }

};



$.initialiseAdvancedFilter();
